import VitalityGroup from '@/utils/classes/VitalityCategory/VitalityGroup';
// Problems criteria
import VCriterionProblemRelativeNb from './relativeNumber';
import VCriterionProblemTrust from './trust';
import VCriterionProblemTypeZone from './perTypeZone';
import VCriterionProblemRecurrence from './recurrence';
import VCriterionProblemResolution from './resolution';
import VCriterionProblemCausesInCompleted from './causesInCompleted';
import VCriterionProblemRelativeSolved from './relativeSolvedNumber';
import VCriterionProblemLeadTime from './leadTime';
import VCriterionProblemLate from './late';
import VCriterionActionLate from './lateActions';


export default new VitalityGroup({
  key: 'problems',
  dataInfo: [
    {
      serverUrl: '/server/problems/get.php',
      specDataKey: 'problems',
      dataTeamKey: 'reportTeam',
    },
    {
      serverUrl: '/server/actions/get.php',
      specDataKey: 'actions',
      dataTeamKey: 'affectTeam',
    },
  ],
  titleTr: 'PROBLEM_SOLVING',
  weight: 3,
  essentialCriteria: [
    VCriterionProblemRelativeNb,
    VCriterionProblemTrust,
    VCriterionProblemTypeZone,
    VCriterionProblemRecurrence,
    VCriterionProblemResolution,
    VCriterionProblemCausesInCompleted,
    VCriterionProblemRelativeSolved,
    VCriterionProblemLate,
    VCriterionActionLate,
  ],
  bonusCriteria: [
    VCriterionProblemLeadTime,
  ],
});
